import { render, staticRenderFns } from "./policyPopup.vue?vue&type=template&id=b85b97e6"
import script from "./policyPopup.vue?vue&type=script&lang=js"
export * from "./policyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports